import React, {useState} from "react";
import PaymentScheduleTable from "./PaymentScheduleTable";
import "./paymentSchedule.scss";

const PaymentSchedule = ({calculationResult, amountError, isHybrid}) => {
    const [isOpen, setIsOpen] = useState(true);

    const toggleTable = () => setIsOpen(prev => !prev);

    return (
        <div className="form-element calculationLayout-element calculationLayout-width">
            <div className="form-element-data static calculationLayout-collaps">
                <h4
                    className='calculationLayout-title'
                    onClick={toggleTable}
                >
                    График платежей
                </h4>
                <div className={`payment-schedule-wrapper ${isOpen ? "open" : ""}`}>
                    <div className="payment-schedule-content">
                        <PaymentScheduleTable calculationResult={calculationResult} amountError={amountError} isHybrid={isHybrid}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentSchedule;
